import * as actionTypes from 'constants/actionTypes';

export const syncTopLevelDataWithFirebase = () => {
  return {
    type: actionTypes.SYNC_TOP_LEVEL_DATA_WITH_FIREBASE,
  };
};
